// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f9XJ","rootNoMargin":"styles_rootNoMargin__2EpSj"};